import React from "react";
import { defaultCompare as naturalSort } from "logic/DefaultCompare";
import { Spinner } from "components/common";
import { Alert, Row, Col, Input } from "components/bootstrap";
import BootstrapModalForm from "components/bootstrap/BootstrapModalForm";
import { StreamsStore } from "stores/streams/StreamsStore";
class IndexSetDeletionForm extends React.Component {
  constructor(props) {
    super(props);
    this._onModalOpen = () => {
      StreamsStore.load((streams) => {
        const assignedStreams = [];
        streams.forEach((stream) => {
          if (stream.index_set_id === this.props.indexSet.id) {
            assignedStreams.push({ id: stream.id, title: stream.title });
          }
        });
        this.setState({ assignedStreams });
      });
    };
    // eslint-disable-next-line react/no-unused-class-component-methods
    this.open = () => {
      this.setState({ showModal: true }, this._onModalOpen);
    };
    this.close = () => {
      this.setState({ showModal: false });
    };
    this._onRemoveClick = (e) => {
      this.setState({ deleteIndices: e.target.checked });
    };
    this._isLoading = () => !this.state.assignedStreams;
    this._isDeletable = () => !this._isLoading() && this.state.assignedStreams.length < 1 && !this.props.indexSet.default;
    this._modalContent = () => {
      if (this._isLoading()) {
        return /* @__PURE__ */ React.createElement(Spinner, { text: "Loading assigned streams..." });
      }
      if (this.props.indexSet.default) {
        return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger" }, "Unable to delete the index set because it is the default index set!")));
      }
      if (!this._isDeletable()) {
        const assignedStreams = this.state.assignedStreams.sort((s1, s2) => naturalSort(s1.title, s2.title)).map((stream) => /* @__PURE__ */ React.createElement("li", { key: `stream-id-${stream.id}` }, stream.title));
        return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger" }, "Unable to delete the index set because it has assigned streams. Remove stream assignments to be able to delete this index set."))), /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement("h4", null, "Assigned streams:"), /* @__PURE__ */ React.createElement("ul", null, assignedStreams))));
      }
      return /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(
        Input,
        {
          id: "remove-data-checkbox",
          type: "checkbox",
          label: "Remove all data for this index set?",
          help: /* @__PURE__ */ React.createElement("span", null, "All indices related to this index set will be deleted."),
          checked: this.state.deleteIndices,
          onChange: this._onRemoveClick
        }
      )));
    };
    this._onDelete = (e) => {
      e.preventDefault();
      if (this._isDeletable()) {
        this.props.onDelete(this.props.indexSet, this.state.deleteIndices);
        this.close();
      }
    };
    this.state = {
      showModal: false,
      assignedStreams: void 0,
      deleteIndices: true
    };
  }
  render() {
    return /* @__PURE__ */ React.createElement(
      BootstrapModalForm,
      {
        show: this.state.showModal,
        title: `Delete index set "${this.props.indexSet.title}"?`,
        "data-telemetry-title": "Delete index set",
        onCancel: this.close,
        onSubmitForm: this._onDelete,
        submitButtonText: "Delete",
        submitButtonDisabled: !this._isDeletable()
      },
      this._modalContent()
    );
  }
}
export default IndexSetDeletionForm;
